import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/layout/Layout";

import PlayerList from "../components/PlayerManagement/PlayerList";
import useRefresh from "../components/Refresh/refresh";
import DashboardTabs from "../components/ui/DashboardTabs";
import getProMapping from "../components/Signups/getProMapping";
import PRO_COLORS from "./proColors";
import HorseRequestsManager from "src/components/HorseManagement/HorseRequestsManager";
import { Button, Card, CardContent, Stack, Snackbar, Alert } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";

function SignupPage({
  eventId,
  clubId,
  gameDate,
  devPort,
  waiverNotifications,
  managerMode,
  setAvailableHorseForLease,
  gameDivisions,
  userName,
}) {
  const [players, setPlayers] = useState([]);
  const [loadingSignups, setLoadingSignups] = useState(true);
  const [proColorMapping, setProColorMapping] = useState();
  const [totalNumberLeasedChukkers, setTotalNumberLeasedChukkers] = useState(0);
  const [
    totalNumberLeasedChukkersAvailable,
    setTotalNumberLeasedChukkersAvailable,
  ] = useState(0);
  const [managerUserId, setManagerUserId] = useState(null);
  const [horseRequestsRefreshTrigger] = useState(0);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  let navigate = useNavigate();
  useRefresh(clubId, devPort);
  console.log("Signup Event" + eventId);

  // Fetch manager's user ID for horse assignment
  useEffect(() => {
    if (managerMode === -1 && userName) {
      fetch(devPort + "system_get_manager/" + userName, {
        credentials: "include",
      })
        .then((response) => response.json())
        .then((data) => {
          if (data && data[0] && data[0][0]) {
            setManagerUserId(String(data[0][0]));
          }
        })
        .catch(() => {});
    }
  }, [devPort, userName, managerMode]);
  const loadPlayers = useCallback(() => {
    console.log(devPort + "player_roster/" + clubId + "/" + eventId);
    fetch(devPort + "player_roster/" + clubId + "/" + eventId, {
      credentials: "include",
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("Player Roster");
        console.log(data);
        const newProColorMapping = {};
        let colorIndex = 0;
        let formattedData = [];
        let totalLeasedChukkers = 0;
        data.map((player) => {
          if (player[11]) {
            totalLeasedChukkers += player[11];
          }
          // Parse horse assignments from JSON (index 14)
          let horseAssignments = [];
          if (player[14]) {
            try {
              horseAssignments = typeof player[14] === 'string' 
                ? JSON.parse(player[14]) 
                : player[14];
              if (!Array.isArray(horseAssignments)) {
                horseAssignments = [];
              }
            } catch (e) {
              console.error("Failed to parse horse assignments:", e);
              horseAssignments = [];
            }
          }
          const formattedPlayerData = {
            player_id: player[0],
            first_name: player[1],
            last_name: player[2],
            uspa_rating: player[3],
            club_rating: player[4],
            count_chukkers_requested: player[5],
            game_id: player[6],
            selected_pro_id: player[7],
            is_club_pro: player[8],
            signup_notes: player[9],
            paid_lease: player[10],
            count_chukkers_leased: player[11],
            up_to_date_waiver: player[12],
            division_chukkers: player[13] ? JSON.parse(player[13]) : {},
            horse_assignments: horseAssignments,
          };
          console.log("FORMATTED PLAYER DATA");
          console.log(formattedPlayerData);
          formattedData.push(formattedPlayerData);
          if (
            (player[7] && !newProColorMapping[player[7]]) ||
            (player[8] && !newProColorMapping[player[0]])
          ) {
            const player_index_mapping = { 7: 7, 8: 0 };
            Object.keys(player_index_mapping).map((index) => {
              if (
                player[index] &&
                !newProColorMapping[player[player_index_mapping[index]]]
              ) {
                newProColorMapping[player[player_index_mapping[index]]] =
                  PRO_COLORS[colorIndex];
                if (colorIndex === PRO_COLORS.length - 1) {
                  colorIndex = 0;
                } else {
                  colorIndex += 1;
                }
              }
              return null;
            });
          }
          return null;
        });
        setProColorMapping(newProColorMapping);
        console.log(newProColorMapping);
        setPlayers(formattedData);
        setTotalNumberLeasedChukkers(totalLeasedChukkers);
        console.log("FOMRATTER");
        console.log(formattedData);
        setLoadingSignups(false);
      });
  }, [devPort, clubId, eventId]);

  // Update horse assignments for a specific player locally (no re-fetch)
  const updatePlayerAssignments = useCallback((playerId, newAssignments) => {
    setPlayers(prevPlayers => 
      prevPlayers.map(player => 
        String(player.player_id) === String(playerId)
          ? { ...player, horse_assignments: newAssignments }
          : player
      )
    );
    // Note: We don't trigger HorseRequestsManager refresh here to avoid flash/reload.
    // HorseRequestsManager updates its own state when its modal is used.
  }, []);

  const [proMapping, setProMapping] = useState();
  useEffect(() => {
    loadPlayers();
    const player_fetcher = devPort + "player_list/" + clubId + "/True";
    getProMapping(
      devPort,
      player_fetcher,
      setProMapping,
      () => {},
      () => {} //setLoadingClubPros
    );
  }, [devPort, clubId, loadPlayers]);
  function deletePlayer(playerId) {
    fetch(devPort + "delete_signup/" + eventId + "/" + playerId, {
      method: "POST",
      credentials: "include",
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        loadPlayers();
      });
  }
  let currentPage = "/signup";
  if (managerMode !== -1) {
    currentPage = "/playersignup";
  }

  const handleSendSignupReminder = () => {
    setSendingEmail(true);
    fetch(devPort + "email_game_signup_reminder", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        clubId: clubId,
        gameId: eventId,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        setSendingEmail(false);
        if (data.error) {
          setSnackbar({
            open: true,
            message: `Failed to send reminders: ${data.error}`,
            severity: "error",
          });
        } else {
          setSnackbar({
            open: true,
            message: `Signup reminders sent to ${data.total_sent} member(s)`,
            severity: "success",
          });
        }
      })
      .catch(() => {
        setSendingEmail(false);
        setSnackbar({
          open: true,
          message: "Failed to send signup reminders",
          severity: "error",
        });
      });
  };

  //if (loadingSignups) {
  //    return <div>Loading Signups ...</div>
  //}
  useEffect(() => {
    console.log(devPort + "get_horse_chukker_game/" + eventId);
    fetch(devPort + "get_horse_chukker_game/" + eventId, {
      credentials: "include",
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data && data[0]) {
          setTotalNumberLeasedChukkersAvailable(data[0][0]);
        }
      });
  }, [devPort, eventId]);

  useEffect(() => {
    setAvailableHorseForLease(
      totalNumberLeasedChukkersAvailable - totalNumberLeasedChukkers
    );
  }, [
    totalNumberLeasedChukkersAvailable,
    totalNumberLeasedChukkers,
    setAvailableHorseForLease,
  ]);
  return (
    <Layout
      managerMode={managerMode}
      waiverNotifications={waiverNotifications}
      devPort={devPort}
    >
      <DashboardTabs
        currentPage={currentPage}
        managerMode={managerMode}
        gameMode="game"
      />
      {managerMode === -1 && eventId && (
        <Card sx={{ mb: 2 }}>
          <CardContent>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Stack>
                <h3 style={{ margin: 0 }}>Send Signup Reminder Emails</h3>
                <p style={{ margin: "8px 0 0 0", color: "#666", fontSize: "14px" }}>
                  Email all club members to sign up or update their chukker requests. Reminders are also sent automatically 24 hours before the signup deadline.
                </p>
              </Stack>
              <Button
                variant="contained"
                color="primary"
                startIcon={<EmailIcon />}
                onClick={handleSendSignupReminder}
                disabled={sendingEmail}
                sx={{ minWidth: 180 }}
                data-testid="send-signup-reminder-email"
              >
                {sendingEmail ? "Sending..." : "Send Reminders"}
              </Button>
            </Stack>
          </CardContent>
        </Card>
      )}
      {/* Horse Requests Manager for managers to see and assign horses */}
      {managerMode === -1 && eventId && (
        <HorseRequestsManager
          devPort={devPort}
          clubId={clubId}
          eventType="games"
          eventId={eventId}
          managerMode={managerMode}
          updatePlayerAssignments={updatePlayerAssignments}
          refreshTrigger={horseRequestsRefreshTrigger}
          externalAssignments={!loadingSignups && players.length > 0 ? players.flatMap(p => p.horse_assignments || []) : undefined}
        />
      )}
      <PlayerList
        devPort={devPort}
        loadingPage={loadingSignups}
        managerMode={managerMode}
        title={"Signups for Game on " + gameDate}
        clubId={clubId}
        gameId={eventId}
        players={players}
        nameEdit={false}
        ratingEdit={false}
        chukkerEdit={true}
        refresh={loadPlayers}
        playerDelete={deletePlayer}
        addPlayer={() => navigate("/addplayer")}
        proColorMapping={proColorMapping}
        tableMode="games"
        proMapping={proMapping}
        totalNumberLeasedChukkers={totalNumberLeasedChukkers}
        totalNumberLeasedChukkersAvailable={totalNumberLeasedChukkersAvailable}
        gameDivisions={gameDivisions}
        updatePlayerAssignments={updatePlayerAssignments}
        managerUserId={managerUserId}
      />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Layout>
  );
}

export default SignupPage;
